/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Event_Group_Retrieved_MessageInputs */

const en_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected event group retrieved successfully`)
};

const fr_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'evenements selectionne recupere avec succes`)
};

const de_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisgruppe erfolgreich abgerufen`)
};

const it_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi selezionato recuperato correttamente`)
};

const ru_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбранная группа событий успешно получена.`)
};

const es_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de eventos seleccionado se recuperó correctamente`)
};

const zh_cn2_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已成功检索所选事件组`)
};

const ja_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントグループが正常に取得されました`)
};

const hi_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित इवेंट समूह सफलतापूर्वक प्राप्त कर लिया गया।`)
};

const pt_pt2_iframe_remote_event_group_retrieved_message = /** @type {(inputs: Iframe_Remote_Event_Group_Retrieved_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos selecionado recuperado com sucesso.`)
};

/**
* | output |
* | --- |
* | "Selected event group retrieved successfully" |
*
* @param {Iframe_Remote_Event_Group_Retrieved_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_event_group_retrieved_message = /** @type {((inputs?: Iframe_Remote_Event_Group_Retrieved_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Event_Group_Retrieved_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "de") return de_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "it") return it_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "ru") return ru_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "es") return es_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "ja") return ja_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "hi") return hi_iframe_remote_event_group_retrieved_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_event_group_retrieved_message(inputs)
	return en_iframe_remote_event_group_retrieved_message(inputs)
});